/**
 * A primitive frame abstraction that allows us to close the frame when we are done with it.
 */
export class Frame<Data> {
    #data: Data;

    get data(): Data {
        return this.#data;
    }

    #onClose: () => void = () => {};

    /**
     * Creator of this object is responsible for handling the onClose callback.
     */
    constructor(data: Data, onClose?: () => void) {
        this.#data = data;
        if (onClose !== undefined) {
            this.#onClose = onClose;
        }
    }

    /**
     * Calling this method means that creator of this object can safely reuse this frame or destroy it.
     */
    close() {
        this.#onClose?.();
        this.#onClose = () => {};
    }
}
